import { render } from "./NavTabs.vue?vue&type=template&id=6b3f4244&scoped=true&ts=true"
import script from "./NavTabs.vue?vue&type=script&lang=ts"
export * from "./NavTabs.vue?vue&type=script&lang=ts"

import "./NavTabs.vue?vue&type=style&index=0&id=6b3f4244&scoped=true&lang=css"
import "./NavTabs.vue?vue&type=style&index=1&id=6b3f4244&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3f4244"]])

export default __exports__